'use client';

import { InvitePageErrorView } from './invite-page-error-view';
import * as Styled from './invite-page.styled';

import { Button, Spinner } from '@capra/core';
import { FC } from 'react';

import type { InvitePageError as InvitePageErrorState } from './invite-page-error-view';
import type { CommonAuthProviderContextValue } from '@modules/auth/providers/CommonAuthProvider/CommonAuthProvider';

export type InvitePageContentProps = {
  isAuthLoading: boolean;
  message: string;
  initialLoad: boolean;
  acceptedOrgId?: string;
  membershipWaitFailed: boolean;
  error?: InvitePageErrorState;
  onRetryMembershipWait?: () => void;
  errorAuth: CommonAuthProviderContextValue;
};

export const InvitePageContent: FC<InvitePageContentProps> = ({
  isAuthLoading,
  message,
  initialLoad,
  acceptedOrgId,
  membershipWaitFailed,
  error,
  onRetryMembershipWait,
  errorAuth,
}) => {
  if (isAuthLoading) {
    return (
      <Styled.Container>
        <Styled.InvitationCard>
          <Styled.StatusContainer>
            <Styled.StatusTitle>Accepting invitation</Styled.StatusTitle>
            <Styled.InviteSpinWrapper key='spin'>
              <Spinner size='lg' />
            </Styled.InviteSpinWrapper>
          </Styled.StatusContainer>
        </Styled.InvitationCard>
      </Styled.Container>
    );
  }

  return (
    <Styled.Container>
      <Styled.InvitationCard>
        {initialLoad && (
          <Styled.StatusContainer>
            <Styled.StatusTitle>{message}</Styled.StatusTitle>
            <Styled.InviteSpinWrapper key='spin'>
              <Spinner size='lg' />
            </Styled.InviteSpinWrapper>
          </Styled.StatusContainer>
        )}

        {acceptedOrgId !== undefined && (
          <Styled.InviteResult
            status={membershipWaitFailed ? 'warning' : 'success'}
            title='Successfully accepted invitation'
            subTitle={
              membershipWaitFailed
                ? 'Your invitation was accepted, but account access is still being set up. Please try again in a moment.'
                : 'We are loading your new account information and you will be redirected shortly.'
            }
            extra={
              membershipWaitFailed
                ? [
                  <Button
                    key='retry-membership'
                    variant='primary'
                    onClick={() => onRetryMembershipWait?.()}
                  >
                    Try Again
                  </Button>,
                ]
                : [
                  <Styled.InviteSpinWrapper key='spin'>
                    <Spinner size='lg' />
                  </Styled.InviteSpinWrapper>,
                ]
            }
          />
        )}

        {error && (
          <InvitePageErrorView error={error} auth={errorAuth} />
        )}

      </Styled.InvitationCard>
    </Styled.Container>
  );
};
